import clsx from 'clsx';
import Icon from 'components/ui/Icon';
import type { InspectorModeHTMLTags } from 'hooks/useLivePreview';
import type { ComponentType } from 'react';

type Props = {
  highlight: string;
  icon?: string;
  iconClasses?: string;
  iconColor?: string;
  wrapper?: ComponentType<{ className: string }> | string;
  wrapperClasses?: string;
  inspectorProps?: InspectorModeHTMLTags;
};

const Highlight = ({
  highlight,
  icon = 'Check',
  iconClasses = '',
  iconColor = '#155263',
  wrapper: Wrapper = 'p',
  wrapperClasses = '',
  inspectorProps,
}: Props): JSX.Element => (
  <Wrapper
    className={clsx('md:text-base mb-3 flex md:items-center', wrapperClasses)}
  >
    <Icon
      className={clsx('w-4 mr-2 shrink-0', iconClasses)}
      type={icon}
      color={iconColor}
    />
    <div {...inspectorProps}>{highlight}</div>
  </Wrapper>
);

export default Highlight;
